/**
 * The badge tone for a ticket status, by category.
 *
 * Statuses are configurable, so the colour follows the category an
 * administrator put the status in rather than its name: anything still being
 * worked is informative, anything waiting is a caution, anything finished is
 * positive. One function, so a status looks the same on every screen.
 */
export function ticketStatusTone(
  category: 'open' | 'pending' | 'resolved' | 'closed' | string,
): 'informative' | 'caution' | 'positive' | 'neutral' {
  if (category === 'resolved' || category === 'closed') return 'positive';
  if (category === 'pending') return 'caution';
  if (category === 'open') return 'informative';
  return 'neutral';
}
